import * as z from "zod";

export const bulkMigrateTeamsToSupportV2 = {
  name: "bulkMigrateTeamsToSupportV2" as const,
  input: z.object({
    teamIds: z.array(z.string()),
    batchSize: z.number().optional(),
    staggerMinutes: z.number().optional(),
  }),
  output: z.object({
    workflowId: z.string(),
    accepted: z.array(z.string()),
    rejected: z.array(z.string()),
  }),
};
export type BulkMigrateTeamsToSupportV2 = z.infer<
  typeof bulkMigrateTeamsToSupportV2.output
>;
